import React from "react";
import { FlameIcon } from "lucide-react";
interface ScarcityBarProps {
  spotsLeft?: number;
  totalSpots?: number;
}
export function ScarcityBar({
  spotsLeft = 7,
  totalSpots = 100
}: ScarcityBarProps) {
  const claimed = Math.round((totalSpots - spotsLeft) / totalSpots * 100);
  return <div className="mt-6 rounded-2xl bg-before/[0.07] p-4 text-left ring-1 ring-before/20" data-id="element-279" data-mp="2q3heetgvjidl">
      <div className="flex items-center justify-between gap-3" data-id="element-280" data-mp="2b708ihrgevyf">
        <p className="flex items-center gap-1.5 text-[15px] font-extrabold text-before" data-id="element-281" data-mp="2b8utfw2q6o2i">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-282" data-mp="2g74psa06rupp" />
          Only {spotsLeft} spots left
        </p>
        <p className="text-sm font-bold text-ink" data-id="element-283" data-mp="228erir1mrozr">{claimed}% claimed</p>
      </div>
      <div className="mt-2.5 h-4 overflow-hidden rounded-full bg-before/15" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-284" data-mp="277977k4awxfn">
        <div className="h-full rounded-full bg-before" style={{
        width: `${claimed}%`
      }} data-id="element-285" data-mp="33m39t4lfn5dc" />
      </div>
      <p className="mt-2 text-[13px] leading-snug text-muted" data-id="element-286" data-mp="2zm2xbphw948x">
        Only {spotsLeft} spots remain at the <strong className="text-ink" data-id="element-287" data-mp="3dcy1iohg6x66">$27 promotional price</strong> before it returns to regular pricing.
      </p>
    </div>;
}